import keyMirror from 'keymirror'

export default keyMirror({
  UPDATE_PROJECT_DATA: null,
  HIDE_ERROR_WARNING: null,
  SHOW_ERROR: null,
  CREATE_KEY_FROM_TMX_FILE: null,
  ENABLE_ANALYZE_BUTTON: null,
  UPDATE_PROJECT_TEMPLATES: null,
})
